import { SortDirection } from '../entities/sort-direction.entity';

export function sortByProperty<T, P extends keyof T>(list: T[], property: P, direction: SortDirection): T[] {
    return [...list].sort((a, b) => {
        if (direction === SortDirection.DESC) {
            return a[property] < b[property] ? 1 : -1;
        } else {
            return a[property] > b[property] ? 1 : -1;
        }
    });
}
